import {useContext} from "react";

import {NavBarContext} from "@/components/navBar/NavBar.utils.tsx";
import {NavBarLogo} from "@/components/navBar/subComponents/NavBarLogo/NavBarLogo.tsx";
import {NavBarToggle} from "@/components/navBar/subComponents/NavBarToggle/NavBarToggle.tsx";

import styles from "./NavBarHeader.module.scss";

export const NavBarHeader = () => {
  const {isMobile} = useContext(NavBarContext);
  return (
    <div className={isMobile ? styles.navBarHeaderMobile : styles.navBarHeader}>
      <NavBarLogo />
      {isMobile && <NavBarToggle />}
    </div>
  );
};
